import { Box, Card, CardContent, Typography } from '@mui/material';

import {
  aboutDeckBodyTextSx,
  aboutDeckCardSx,
  aboutDeckListSx,
  aboutDeckTitleSx,
} from './AboutDeck.styles';

function AboutDeck() {
  return (
    <Card sx={aboutDeckCardSx}>
      <CardContent>
        <Typography variant="h5" component="h2" color="primary" sx={aboutDeckTitleSx}>
          About Our Deck
        </Typography>
        <Typography variant="body2" paragraph>
          This reading uses the complete Rider-Waite Tarot deck, consisting of 78 cards divided into
          two parts:
        </Typography>
        <Box component="ul" sx={aboutDeckListSx}>
          <li>
            <Typography variant="body2">
              <strong>Major Arcana (22 cards):</strong> Represent major life themes and spiritual
              lessons.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Minor Arcana (56 cards):</strong> Divided into four suits—Cups (emotions),
              Swords (intellect), Coins (material), and Wands (creativity).
            </Typography>
          </li>
        </Box>
        <Typography variant="body2" sx={aboutDeckBodyTextSx}>
          Each card can appear upright or reversed, offering layers of meaning and insight into your
          question or situation.
        </Typography>
      </CardContent>
    </Card>
  );
}

export default AboutDeck;
